// Import necessary dependencies
var React               = require("react");
var DialogController    = require("fdna-common-components/dist/components/Dialog/Dialog").DialogController;
var DialogContent       = require("fdna-common-components/dist/components/Dialog/DialogContent");
var Button              = require("fdna-common-components/dist/components/Forms/Button");
var Network             = require("../common/network/Network");

// Styles for the confirmation dialog
var dialogStyle = {
    textAlign: "center",
};

// Function to create a confirmation modal dialog
var confirmModal = function (title, content, buttonLabel1, buttonLabel2, callback1, callback2) {
    return (
        <div className="lost-connection" style={dialogStyle}>
            <DialogContent className="new-dialog-content">
                <div>
                    <svg width="24" height="28" viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.072 21.085v1.249H6.122v-1.249c0-1.36 3.673-6.844 3.673-7.542 0-.662-3.673-6.149-3.673-7.507V4.753h11.95v1.283c0 1.358-3.689 6.845-3.689 7.507 0 .698 3.689 6.182 3.689 7.542zm-6.507-6.714S8.969 16.91 7.95 19.903v.769h8.307v-.769c-1.314-3.273-3.645-5.532-3.645-5.532h-1.047zm7.642-8.335V3.468h4.245V0H0v3.468h4.942v2.568c0 1.92 3.437 7.159 3.614 7.539-.177.385-3.614 5.588-3.614 7.51v2.875H0v3.452h23.452V23.96h-4.245v-2.875c0-1.922-3.394-7.125-3.57-7.542.176-.386 3.57-5.587 3.57-7.507z" fill="#3799C2" fill-rule="evenodd" />
                    </svg>
                </div>
                <div style={{ margin: '25px 0' }}>{content}</div>
                <div style={{display: 'flex',justifyContent: 'space-between'}}>
                    <Button className="analyzing-confirmation-btn" label={buttonLabel1} onClick={callback1} />
                    <Button label={buttonLabel2} onClick={callback2} />
                </div>
            </DialogContent>
        </div>
    );
};

// Define the AuthMiddleware component
var AuthMiddleware = React.createClass({
    getInitialState: function () {
        var initialState = {
            setConfirmState: false,
            isDialogOpen: false
        };
        // Check if the browser supports Web Workers and the device is not a mobile device
        if (typeof Worker !== "undefined" && !(/Mobi|Android/i.test(navigator.userAgent))) {
            // Initialize the timer with the provided value or a default value
            initialState.timeLeft = (window.sessionLiftTime) * 60;
            // Create a new Worker if Web Workers are supported and the device is not a mobile device
            initialState.worker = new Worker('authTimerWorker.js');
        } else {
            // Web Workers are not supported or the device is a mobile device, handle the situation accordingly

            // You can set a different value or take some other action here if needed
            initialState.timeLeft = (window.sessionLiftTime) * 60; // Set to 0 or any other default value
        }
        return initialState;
    },

    // Function to reset the timer
    resetTimer: function (event) {
        var self = this;
        // Reset the timer when the user moves the mouse or presses any key
        clearInterval(self.timerInterval);
        // If the confirmation dialog is open, reset the timer to 60 seconds
        // Otherwise, reset the timer to sessionLiftTime
        var newTimeLeft = this.state.isDialogOpen ? 60 : (window.sessionLiftTime) * 60;
        self.setState({
            timeLeft: newTimeLeft,
            setConfirmState: this.state.isDialogOpen,
        });
        // Send a 'reset' command to the worker with the new time left
        if (this.state.worker) {
            this.state.worker.postMessage({
                cmd: 'reset',
                timeLeft: newTimeLeft
            });
        }
        self.startTimer();
    },

    // Component lifecycle method: Called after the component is mounted
    componentDidMount: function () {

        // Check if the worker is defined before accessing its properties
        if (this.state.worker) {
            this.state.worker.postMessage({
                cmd: 'start',
                timeLeft: this.state.timeLeft
            });
            this.state.worker.onmessage = (e) => {
                if (e.data.cmd === 'showDialog') {
                    this.showDialog();
                } else if (e.data.cmd === 'logout') {
                    this.onOkPressLogout();
                } else if (e.data.cmd === 'updateTime') {
                    this.setState({ timeLeft: e.data.timeLeft });
                }
            };
        }
        this.startTimer();
        // Listen for mousemove events to reset the timer
        window.addEventListener("mousemove", this.resetTimer);
        // Listen for beforeunload event to clear the event listener
        window.addEventListener("beforeunload", this.handleBeforeUnload);
        // Listen for keydown events to reset the timer
        window.addEventListener("keydown", this.handleKeyDown);
    },

    // Component lifecycle method: Called before the component is unmounted
    componentWillUnmount: function () {
        clearInterval(this.timerInterval);
        if (this.state.worker) {
            this.state.worker.terminate();
        }
        // Remove the event listeners when the component unmounts
        window.removeEventListener("mousemove", this.resetTimer);
        window.removeEventListener("beforeunload", this.handleBeforeUnload);
        window.removeEventListener("keydown", this.handleKeyDown);
    },

    // Function to handle user's request to log out
    onOkPressLogout: function () {
        try {
            localStorage.clear();
            sessionStorage.clear();
            document.cookie.split(";").forEach(function (c) {
                document.cookie = c
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });
            let bases = document.getElementsByTagName("base");
            let baseHref = null;
            let url = window && window.appName ? Network.apiBase + "access/logout?app=" + window.appName : "access/logout";
            if (bases.length > 0) {
                baseHref = bases[0].href;
            }
            window.location.href = baseHref + url;
        } catch (e) {

        }
    },

    // Function to handle user's request to stay logged in
    onStillLoginPress: function () {
        this.setState({ isDialogOpen: false });
        this.resetTimer();
        DialogController.closeDialog();
    },

    // Function to start the timer
    startTimer: function () {
        var self = this;
        this.timerInterval = setInterval(function () {
            // Check if the tab is in the background
            if (document.visibilityState === 'visible') {
                self.setState(function (prevState) {
                    var newTimeLeft = prevState.timeLeft - 1;
                    if (newTimeLeft === 60) {
                        // Display the confirm dialog 1 minute before timer expires
                        DialogController.openDialog(
                            confirmModal(
                            "Warning",
                            "Your account will be logged out in 1 minute",
                            "I'M STILL ANALYZING",
                            "OK",
                            self.onStillLoginPress,
                            self.onOkPressLogout,
                            ),
                            { showClose: false }
                        );
                        return { timeLeft: newTimeLeft, setConfirmState: true };
                    }
                    return { timeLeft: newTimeLeft };
                });
            }
            if (self.state.timeLeft <= 0) {
                clearInterval(self.timerInterval);
                self.onOkPressLogout();
            }
        }, 1000);
    },

    showDialog: function () {
        this.setState({
            isDialogOpen: true
        });
        DialogController.openDialog(
            confirmModal(
            "Warning",
            "Your account will be logged out in 1 minute",
            "I'M STILL ANALYZING",
            "OK",
            this.onStillLoginPress,
            this.onOkPressLogout,
            ),
            { showClose: false }
        );
    },

    // Function to handle the beforeunload event
    handleBeforeUnload: function (event) {
        var self = this;
        // Clear the event listener only if the user refreshes the page manually
        if (event.type === "beforeunload") {
            window.removeEventListener("beforeunload", self.handleBeforeUnload);
        }
    },

    // Function to handle keydown events
    handleKeyDown: function (event) {
        var self = this;
        // Reset the timer when the user presses any keyboard key
        self.resetTimer(event);
    },

    // Render method to display the timer
    render: function () {
        return (
            // <div>
            //     {Math.floor(this.state.timeLeft / 60)}:{this.state.timeLeft % 60}
            // </div>
            null
        );
    },
});

module.exports = AuthMiddleware;


// WEBPACK FOOTER //
// ./authMiddleware/authMiddleware.js